import * as React from 'react';
import loadable from '@loadable/component';
import withMicroFrontendProps, { SEOHead } from 'AppShell/Microfrontend';

const HalloWelt = loadable(() => import('mf-hallo-welt/Main'), { ssr: true });
const HalloWeltSecondary = loadable(() => import('mf-hallo-welt/Secondary'), { ssr: true });

const HalloWeltWithBellaProps = withMicroFrontendProps(HalloWelt, 'mf-hallo-welt');
const HalloWeltSecondaryWithBellaProps = withMicroFrontendProps(HalloWeltSecondary, 'mf-hallo-welt');

const HalloWeltMicroFrontend = () => (
    <div>
        <SEOHead noIndex />
        <HalloWeltWithBellaProps />
        <HalloWeltSecondaryWithBellaProps />
    </div>
);

export default HalloWeltMicroFrontend;
